var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fee"},[_c('div',{staticClass:"fee-title"},[_vm._v("\n            费率表\n        ")])]),_c('div',{staticClass:"sub-title"},[_vm._v("费率：是指您为货物价值投保时需要支付的保费，“保费=货物价值（即：保额）× 费率”。")]),_c('img',{staticClass:"feilv",attrs:{"src":require("../assets/feilv.png"),"alt":""}})])
}]

export { render, staticRenderFns }